export default __webpack_public_path__ + "static/media/image1.96b666dc.jpeg";